// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__m3vvt","select":"styles_select__8RrQV","suffixElement":"styles_suffixElement__SxBE+","error":"styles_error__0plYd"};